import React from "react";
import { useDispatch } from "react-redux";

import { makeProfileData } from "../../../actions/storage";
import AsyncGet from "../../../components/AsyncGet";
import Button from "../../../components/Field/Button";

export default function DeletePhoto() {
    const dispatch = useDispatch();
    return (
        <AsyncGet
            url="/account/image"
            permissionText="Delete Image"
            method="DELETE"
            onFetch={({ data }) => {
                dispatch(makeProfileData(data))
            }}
            render={({ loadFromAPI }) => {
                return (
                    <Button onClick={loadFromAPI} color="buttonPrimaryWithOutBg" label="DELETE" />
                )
            }}
        />
    )
}
